import React from 'react';
import PropTypes from 'prop-types';
import ExerciseVideoBlock from './ExerciseVideoBlock';
import VideoAndUrlInput from './VideoAndUrlInputs';

// Single switch point between the unified video block and the legacy
// video/URL input, shared by all the Create*FormInputs components.
const ExerciseVideoSection = ({
  errors,
  touched,
  mediaType,
  videoUrlValue,
  mediaUrlValue,
  mediaIdValue,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  containerWidth,
  isDisabled,
  urlButtonValue,
  unifiedVideoFlow,
}) => (
  unifiedVideoFlow ? (
    <ExerciseVideoBlock
      errors={errors}
      touched={touched}
      mediaType={mediaType}
      videoUrlValue={videoUrlValue}
      mediaUrlValue={mediaUrlValue}
      mediaIdValue={mediaIdValue}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      setFieldError={setFieldError}
      containerWidth={containerWidth}
      isDisabled={isDisabled}
    />
  ) : (
    <VideoAndUrlInput
      errors={errors}
      touched={touched}
      mediaType={mediaType}
      videoUrlValue={videoUrlValue}
      mediaUrlValue={mediaUrlValue}
      setFieldValue={setFieldValue}
      urlButtonValue={urlButtonValue}
      containerWidth={containerWidth}
      setFieldTouched={setFieldTouched}
      setFieldError={setFieldError}
      isDisabled={isDisabled}
    />
  )
);

ExerciseVideoSection.propTypes = {
  errors: PropTypes.shape({ videoUrl: PropTypes.string }),
  touched: PropTypes.shape({ videoUrl: PropTypes.bool }),
  mediaType: PropTypes.string,
  videoUrlValue: PropTypes.string,
  mediaUrlValue: PropTypes.string,
  mediaIdValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  containerWidth: PropTypes.number,
  isDisabled: PropTypes.bool,
  urlButtonValue: PropTypes.string,
  unifiedVideoFlow: PropTypes.bool,
};

ExerciseVideoSection.defaultProps = {
  errors: {},
  touched: {},
  mediaType: '',
  videoUrlValue: '',
  mediaUrlValue: '',
  mediaIdValue: null,
  containerWidth: 0,
  isDisabled: false,
  urlButtonValue: '',
  unifiedVideoFlow: false,
};

export default ExerciseVideoSection;
